import { api } from '@packages/backend/convex/_generated/api';
import { createFileRoute, Link } from '@tanstack/react-router';
import { useQuery } from 'convex-helpers/react';
import { ArrowLeft } from 'lucide-react';
import { ErrorAlert } from '@/components/ErrorAlert';
import { EftposIntegrationCard } from '@/components/ipads/EftposIntegrationCard';
import { IPadDetailsCard } from '@/components/ipads/IPadDetailsCard';
import { ActionButton } from '@/components/ui+/ActionButton';
import { LoadingIcon } from '@/components/ui+/LoadingIcon';

export const Route = createFileRoute('/a/ipads/$deviceId')({
  staticData: {
    breadcrumbs: [{ label: 'iPads', url: '/a/ipads' }, { label: 'Details' }],
  },
  component: Component,
});

function Component() {
  const { deviceId } = Route.useParams();
  const { data, error, isError, isPending } = useQuery(api.iPads.adminGetDevice, { deviceId });

  if (isPending) return <LoadingIcon />;
  if (isError) return <ErrorAlert message={error.message} title="Error loading iPad details" />;
  if (!data) return <div>iPad not found.</div>;

  const { device, restaurantName, printerName, heartbeats } = data;

  return (
    <div>
      <div className="mb-4">
        <ActionButton asChild variant="outline" size="sm">
          <Link to="/a/ipads">
            <ArrowLeft className="h-4 w-4" />
            Back to list
          </Link>
        </ActionButton>
      </div>

      <IPadDetailsCard
        device={device}
        heartbeats={heartbeats}
        printerName={printerName}
        restaurantName={restaurantName}
      />

      {device.restaurantId && (
        <EftposIntegrationCard restaurantId={device.restaurantId} posTerminalUuid={device.uuid} />
      )}
    </div>
  );
}
